import { render } from "./purchaseInfo.vue?vue&type=template&id=297e8612&scoped=true"
import script from "./purchaseInfo.vue?vue&type=script&lang=js"
export * from "./purchaseInfo.vue?vue&type=script&lang=js"

import "./purchaseInfo.vue?vue&type=style&index=0&id=297e8612&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297e8612"]])

export default __exports__